import React from "react";

// import generic component
import { Activity } from "app/userManagement/modules/generic";

const ProviderActivity = () => {
  return (
    <>
      <Activity />
    </>
  );
};

export default ProviderActivity;
